import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import DrunkDrivingGame from './components/DrunkDrivingGame';
import './App.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<DrunkDrivingGame />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
